module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<button class="' +
((__t = ( styles.submitButton )) == null ? '' : __t) +
'" type="submit">\n  ' +
((__t = ( label || 'Submit' )) == null ? '' : __t) +
'\n</button>\n';

}
return __p
}